<ion-content class="onboarding-content" [scrollY]="false">
  <div class="background">
    <img src="assets/images/field-background.png" alt="background" class="bg-image" />
  </div>

  <div class="onboarding-wrapper">
    <swiper-container
      #swiper
      init="false"
      mcmSwiper
      [swiperActiveIndex]="initialSlide"
      (swiperSlideChange)="onSlideChange($event)"
      pagination="true"
      class="swiper-container">

      @for (step of STEPS; track step.title) {
        <swiper-slide>
          <div class="slide-content">
            <div class="image-wrapper">
              <img [src]="step.image" alt="Onboarding step" class="step-image" />
            </div>
            <div class="text-wrapper">
              <p class="step-title">{{ step.title | translate }}</p>
            </div>
          </div>
        </swiper-slide>
      }
    </swiper-container>

    <div class="onboarding-footer">
      <app-button
        [text]="'MTR_ONBOARDING_CONTINUE'"
        expand="block"
        extraClasses="mcm-button--gradient mcm-button--block"
        (onClick)="nextStep()">
      </app-button>
      <app-button
        [text]="'MTR_ONBOARDING_SKIP'"
        expand="block"
        extraClasses="mcm-button--block"
        (onClick)="skipOnboarding()">
      </app-button>
    </div>
  </div>
</ion-content>
